// Footer.jsx
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { BsFileEarmarkCheck } from "react-icons/bs";
import { ImFacebook } from "react-icons/im";
import { TiSocialTwitter } from "react-icons/ti";
import { FaInternetExplorer } from "react-icons/fa";
import { AiFillYoutube } from "react-icons/ai";
import { BsGoogle, BsMicrosoft } from "react-icons/bs";
import { GrOracle, GrVmware } from "react-icons/gr";
import { SiFortinet, SiNetapp } from "react-icons/si";
import { FiPhone } from "react-icons/fi";
import { MdHome, MdFax } from "react-icons/md";
import { useTranslation } from "react-i18next";
import i18n from "../../language/i18n";
import { normalizeLang } from "../../utils/localeDataLoader";
import { getContactsByLanguage } from "../../apis/contacts";
import { getNavMenuByLanguage } from "../../apis/navMenus";
import { getBusinessLicenseByLanguage } from "../../apis/businessLicenses";

const imgQR = require("../../images/QR/qrfooter.png");
const imglogo = require("../../images/Logo/Logo HSV_01.png");

function Footer() {
  const [activeMenu, setActiveMenu] = useState("Trang chủ");
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [listMenuFooter, setListMenuFooter] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [currentLang, setCurrentLang] = useState(normalizeLang(i18n.language));
  const [bizLicense, setBizLicense] = useState(null);

  const loadContacts = async () => {
    try {
      const languageCode = normalizeLang(i18n.language);
      const data = await getContactsByLanguage(languageCode);
      setContacts(data);
    } catch (error) {
      console.error("Lỗi khi tải danh sách liên hệ footer:", error);
    }
  };

  const loadMenuFooter = async () => {
    try {
      const lang = normalizeLang(i18n.language);
      const data = await getNavMenuByLanguage(lang);
      const footerMenu = data.map((item) => ({
        id: item.id,
        text: item.title,
        slug: item.slug,
      }));
      setListMenuFooter(footerMenu);
    } catch (error) {
      console.error("Failed to load footer menu from API:", error);
    }
  };

  const loadBizLicense = async () => {
    const lang = normalizeLang(i18n.language);
    const data = await getBusinessLicenseByLanguage(lang);
    setBizLicense(data);
  };

  const handleLangChange = () => {
    setCurrentLang(normalizeLang(i18n.language));
    loadMenuFooter();
    loadContacts();
    loadBizLicense();
  };

  useEffect(() => {
    loadMenuFooter();
    loadContacts();
    loadBizLicense();
    i18n.on("languageChanged", handleLangChange);
    return () => {
      i18n.off("languageChanged", handleLangChange);
    };
  }, []);

  const handleActiveMenu = (menuItem, slug) => {
    setActiveMenu(menuItem);
    if (slug !== undefined && slug !== null) {
      const targetPath = slug.startsWith('/') ? slug : `/${slug}`;
      navigate(targetPath);
    }
  };

  return (
    <footer className="footer">
      <div className="layout_container">
        <div className="footer_top">
          <div className="row">
            {/* Cột 1: Logo + tên công ty */}
            <div className="col-xs-12 col-md-4 col-lg-3">
              <div className="footer_brand">
                <img src={imglogo} alt="HSV Logo" />
              </div>
            </div>

            {/* Cột 2: Hai văn phòng hiển thị song song */}
            {/* Đã thay inline-style bằng class footer-col-mid */}
            <div className="col-xs-12 col-md-6 footer-col-mid">
              <div className="footer_offices">
                {contacts[0] && (
                  <div className="office_item">
                    <h3>{contacts[0]?.officeName}</h3>
                    <p>
                      <MdHome className="icon-contact" />
                      <span>
                        {contacts[0]?.address
                          ?.split(/(?<=,)\s*/)
                          .map((part, idx) => (
                            <span key={idx} style={{ display: "inline-block", whiteSpace: "nowrap" }}>
                              {part}{" "}
                            </span>
                          ))}
                      </span>
                    </p>
                    <p>
                      <FiPhone className="icon-contact" />
                      Hotline: {contacts[0]?.phone}
                    </p>
                    <p>
                      <MdFax className="icon-contact" />
                      Fax: {contacts[0]?.fax}
                    </p>
                  </div>
                )}
                {contacts[1] && (
                  <div className="office_item">
                    <h3>{contacts[1]?.officeName}</h3>
                    <p>
                      <MdHome className="icon-contact" />
                      <span>
                        {contacts[1]?.address
                          ?.split(/(?<=,)\s*/)
                          .map((part, idx) => (
                            <span key={idx} style={{ display: "inline-block", whiteSpace: "nowrap" }}>
                              {part}{" "}
                            </span>
                          ))}
                      </span>
                    </p>
                    <p>
                      <FiPhone className="icon-contact" />
                      Hotline: {contacts[1]?.phone}
                    </p>
                    <p>
                      <MdFax className="icon-contact" />
                      Fax: {contacts[1]?.fax}
                    </p>
                  </div>
                )}
              </div>
            </div>

            {/* Cột 3: Kết nối + QR + đối tác */}
            {/* Đã thay inline-style bằng class footer-col-right */}
            <div className="col-xs-12 col-md-12 footer-col-right">
              <div className="footer_social">
                <h3 className="footer_connect-title">{t("footer.connect")}</h3>
                <div className="footer_icons">
                  <div className="footer_icons-left">
                    <p
                      onClick={() =>
                        window.open(
                          "https://www.facebook.com/profile.php?id=100063723542675",
                        )
                      }
                    >
                      <ImFacebook />
                    </p>
                    {/* <p onClick={() => window.open("https://www.hsv.com.vn")}>
                      <TiSocialTwitter />
                    </p>
                    <p onClick={() => window.open("https://www.hsv.com.vn")}>
                      <FaInternetExplorer />
                    </p> */}
                    <p
                      onClick={() =>
                        window.open(
                          "https://www.youtube.com/watch?v=kYRAM1ZohXM",
                          "_blank"
                        )
                      }
                    >
                      <AiFillYoutube />
                    </p>
                    {/* <p onClick={() => window.open("https://www.hsv.com.vn")}>
                      <BsGoogle />
                    </p> */}
                  </div>
                </div>
                <div className="footer_qr">
                  <img src={imgQR} alt="QR Code" />
                </div>
                {/* <div className='footer_icons'>
                                    <div className='footer_icons-left'>
                                        <p onClick={() => window.open("https://www.microsoft.com/vi-vn")}><BsMicrosoft /></p>
                                        <p onClick={() => window.open("https://www.oracle.com/")}><GrOracle /></p>
                                        <p onClick={() => window.open("https://www.fortinet.com/")}><SiFortinet /></p>
                                        <p onClick={() => window.open("https://www.vmware.com/products/workstation-pro/workstation-pro-evaluation.html")}><GrVmware /></p>
                                        <p onClick={() => window.open("https://www.netapp.com/")}><SiNetapp /></p>
                                    </div>
                                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {bizLicense && (
        <div className="footer_biz">
          <BsFileEarmarkCheck className="footer_biz-icon" />
          <p>
            <span className="footer_biz-label">{bizLicense.name}: </span>
            <span className="footer_biz-number">
              {bizLicense.licenseNumber}
            </span>
            <span className="footer_biz-issuer"> — {bizLicense.issuer}</span>
          </p>
        </div>
      )}

      <div className="footer_bottom" style={{ justifyContent: "center" }}>
        <p>{t("footer.copyright")}</p>
        {/* <ul className="footer_bottom-menu">
                    {listMenuFooter.map(value => (
                        <li key={value.id} className={activeMenu === value.text ? "active" : ""} onClick={() => handleActiveMenu(value.text, value.slug)}>{value.text}</li>
                    ))}
                </ul> */}
      </div>
    </footer>
  );
}
export default Footer;
